export default "/images/question-circle.svg?c83e69f6c91497090df186f44cf7974b";